<div
  class="flex items-center justify-center"
  *ngIf="activeUnit$ | async as unit"
  topBarUnitTree
  (onHiddenElements)="hiddenUnitUuids$.next($event)"
>
  <ng-container *ngIf="hiddenUnits$ | async as hiddenUnits">
    <button
      mat-icon-button
      type="button"
      *ngIf="hiddenUnits.length"
      [matMenuTriggerFor]="childrenMenu"
      [matMenuTriggerData]="{ units: hiddenUnits }"
    >
      <mat-icon>more_vert</mat-icon>
    </button>
  </ng-container>
  <div class="flex items-center justify-center" [attr.data-uuid]="obj.uuid" *ngFor="let obj of smartHierarchy$ | async" #unitHierarchyItem>
    <button mat-button (click)="onSelectUnit.next(obj)">{{ obj.title }}</button>
    <span class="text-gray-300">/</span>
  </div>
  <a mat-button class="flex-none" [routerLink]="['/app/units', unit.uuid]">{{ unit.title }}</a>
  <button
    mat-icon-button
    class="flex-none"
    type="button"
    [matMenuTriggerFor]="childrenMenu"
    [matMenuTriggerData]="{ units: unit.children }"
    *ngIf="unit.children && unit.children.length"
  >
    <mat-icon>keyboard_arrow_down</mat-icon>
  </button>

  <button mat-icon-button type="button" (click)="showUnitSearch()" *awIsGod>
    <mat-icon>search</mat-icon>
  </button>
</div>

<mat-menu #childrenMenu="matMenu" [classList]="'Dropdown-menu Dropdown-menu--auto-width'">
  <ng-template matMenuContent let-units="units">
    <button mat-menu-item type="button" *ngFor="let unit of units | orderBy: 'title'" (click)="onSelectUnit.next(unit)">
      {{ unit.title }}
    </button>
  </ng-template>
</mat-menu>
